import { render, staticRenderFns } from "./formilyTodoForm-new.vue?vue&type=template&id=08cfd325&scoped=true"
import script from "./formilyTodoForm-new.vue?vue&type=script&lang=js"
export * from "./formilyTodoForm-new.vue?vue&type=script&lang=js"
import style0 from "./formilyTodoForm-new.vue?vue&type=style&index=0&id=08cfd325&prod&scoped=true&lang=less"
import style1 from "./formilyTodoForm-new.vue?vue&type=style&index=1&id=08cfd325&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cfd325",
  null
  
)

export default component.exports